<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="MaterialTable1" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :isBusy="isBusy" :table_height_adjust="-8"
        :hb_table_class="'hb_table_invent_class1'" :loading_width="40" @on_query="on_query"
        :show_toolbar_button="[0, 0, 0, 0, 0]" @current_changed="current_changed"
        tableref="2cd72c17db8641189284f8be1d2b8318">
        <template #query>
          {{ $t("common.company") }}：
          <el-select v-model="dataAreaId" filterable clearable :placeholder="$t('common.company')" style="width: 120px">
            <el-option v-for="item in $store.state.biz_data.baseData.CompanyInfo" :key="item.DataArea"
              :label="item.DataArea" :value="item.DataArea"></el-option>
          </el-select>
          {{ $t("common.invent") + $t("common.num") }}：<el-input clearable size="small" style="width: 150px"
            v-model="ItemId"></el-input>
          {{ $t("common.invent") + $t("common.name") }}：<el-input clearable size="small" style="width: 200px"
            v-model="NameAlias"></el-input>
          {{ $t("common.customer") + $t("common.account") }}：<el-input clearable size="small" style="width: 150px"
            v-model="TEC_CustAccount">
          </el-input>
          {{ $t("common.customer") + $t("common.name") }}：<el-input clearable size="small" style="width: 200px"
            v-model="DW_CustName"></el-input>
        </template>
        <!-- <template #toolbar>
          <el-tooltip content="数据同步" placement="top" effect="light">
            <el-button type="info" plain style="width: 55px" class="ml-2" @click="InvokeData"><i class="iconfont icon-refresh"></i></el-button>
          </el-tooltip>
        </template> -->
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import BaseModal from "../components/modals/baseModal"
import TestQueryPanel from "../components/base/TestQueryPanel"
import * as InventTableController from "../../controllers/base/InventTableController"

export default {
  name: "InventTable",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_invent",
      },
      fields: InventTableController.fields.detail_fields,
      isBusy: false,
      dataAreaId: "",
      ItemId: "",
      NameAlias: "",
      TEC_CustAccount: "",
      DW_CustName: "",
    }
  },
  created() { },
  methods: {
    //#region 查询
    async on_query(set_data, date_range) {
      this.isBusy = true
      if (_.isNull(date_range)) {
        this.msgModal(this.$t("notify.wait_too_long")).then(
          async (value) => {
            if (value) {
              await this.excuteQuery(set_data, date_range)
            }
            else {
              this.isBusy = false
              set_data([])
            }
          }
        )
      } else {
        await this.excuteQuery(set_data, date_range)
      }
    },
    async excuteQuery(set_data, date_range) {
      let _fromDate = "",
        _toDate = ""
      let _params = {}
      _params.is_deleted_ax = "0"
      _params.NameAlias = { like: "%" + this.NameAlias + "%" }
      _params.DW_CustName = { like: "%" + this.DW_CustName + "%" }
      if (this.ItemId != "") {
        _params.s_ItemId = this.ItemId
      }
      if (this.dataAreaId != "") {
        _params.dataAreaId = this.dataAreaId
      }
      if (this.TEC_CustAccount != "") {
        _params.s_CustAccount = this.TEC_CustAccount
      }

      if (
        !_.isNull(date_range) &&
        this.ItemId == "" &&
        this.dataAreaId == "" &&
        this.NameAlias == "" &&
        this.DW_CustName == "" &&
        this.TEC_CustAccount == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["fromDate"] = _fromDate
        _params["toDate"] = _toDate
        // _params["createdDateTime"] = { ">=": _fromDate, "<=": _toDate }
      }
      set_data([])
      this.$forceUpdate()
      let _result = await InventTableController.methods.getItemData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["createdDateTime"], ["desc"]))
      }
      this.isBusy = false
    },
    //#endregion

    //#region 保存

    //#endregion


    current_changed(old, current) { },
    async InvokeData() {
      // this.isBusy_table1 = true;
      // this.$refs.InventTable1.SetData([]);
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.in_async"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      let _params = {
        company: "070",
        tableName: "secp_InventTable",
        ItemId: "", //不传则查询所有
      }
      let _is_wait = true
      // setTimeout(() => {
      //   this.msgToasts(this.$t("notify.async_timeout"), "info");
      //   loading.close()
      //   _is_wait = false
      //   return
      // }, 15000);
      let _result = await InventTableController.methods.pickAndInvoke(_params)
      if (!_.isNull(_result) && _result) {
        loading.close()
        // this.$refs.InventTable1.SetData(_.orderBy(_result, ["modifiedDateTime"], ["desc"]));
        if (_is_wait) {
          this.msgToasts(this.$t("notify.async_success"), "success")
        }
      }
      // this.isBusy_table1 = false;
    },
  },
}
</script>
<style>
.hb_table_invent_class1 {
  /* width: auto; */
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 310rem;
}
</style>
